import { computed,reactive } from 'vue'

const urlMap = {
  'profleet.net': 'https://tos.ald.vinli.eu',
  's01-ald': 'https://tos.s01-ald.vinli.eu',
  'd01.vin.li': 'https://tos.d01.vin.li',
}

export default function () {
  const host = reactive(window.location.host)
  const isLocal = computed(() => host.includes('localhost') || host.includes('127.0.0.1'))
  const path = computed(() => {
    // default to prod
    let url = urlMap['profleet.net']
    if (isLocal.value) {
      // override with envar for local dev
      const base = process.env.VUE_APP_BASE_HOST
      url = base.replace('fleet', 'tos')
    } else {
      // find with the host
      Object.keys(urlMap).forEach(u => {
        if (host.includes(u)) {
          url = urlMap[u]
        }
      })
    }
    return `${url}/api/v1/terms`
  })
  return {
    host,
    isLocal,
    path,
  }
}
